import { useEffect } from 'react';
import { useAuth } from './auth';
import { setQueueUser } from './queue';

/** Keeps the offline queue tagged with the signed-in driver's id. */
export function QueueUserBinder() {
  const { user } = useAuth();
  useEffect(() => {
    setQueueUser(user?.id ?? null);
  }, [user?.id]);
  return null;
}
